import {SnSButton} from "./SnSButton.js";
import {isWebView} from "../../store.js";
import {mobileOpenSocialSignUpPopup} from "../../../../bridge/renewal-signup/index.js";

export class AppleButton extends SnSButton {
    setup() {
        this.$props.isRender = !!window.appleApiAvailable
    }

    getButtonDataJson() {
        return {
            snsType: "apple",
            id: "appleLoginButton",
            className: `login-apple`,
            buttonText: i18next.t(login.applestrt)
        }
    }

    setEvent() {
        const {id, snsType} = this.getButtonDataJson();
        const AppleLogin = Mutil.requireIIFE("AppleLogin");
        this.addEvent("click.prevent", `#${id}`, (e) => {
            if(isWebView()) {
                mobileOpenSocialSignUpPopup( {appName : snsType.toUpperCase()});
                return
            }
            AppleLogin.clickAppleLoginButton(e)
        });
    }

}